package it.neckar.lizergy.model.financial.currency

import kotlinx.serialization.KSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

/**
 * Compatible serializer - since we used to serialize the money object as deciCents (Long)
 */
object MoneyFractionAsCentiCentsSerializer : KSerializer<MoneyFraction> {
  override val descriptor: SerialDescriptor = Double.serializer().descriptor

  override fun serialize(encoder: Encoder, value: MoneyFraction) {
    encoder.encodeLong(value.centiCents)
  }

  override fun deserialize(decoder: Decoder): MoneyFraction {
    val deciCents = decoder.decodeLong() //Decode with double - works with Int and Long, too
    return MoneyFraction.centiCents(deciCents)
  }
}
